/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import ResponsivePicture from '../../Elements/ResponsivePicture/ResponsivePicture';
import { constructCn } from '../../../utilities/helperFunctions';
import { breakpoints } from '../imageDefaults';

import './LinkContent.scss';
import { SEARCH_RESULTS } from '../../../pages/Search/constants';

const PreviewSection = ({
    noBorderPaddingImage,
    preview: { previewTitle, previewDescription, previewImage, embedHtml },
}) => {
    const showVideo = !!embedHtml;
    const showPreviewImage = !showVideo && previewImage && previewImage.src;
    const previewDescriptionClassName = constructCn(
        'preview-description-wrapper',
        !showPreviewImage &&
            !showVideo &&
            'preview-description-wrapper--grey-border'
    );
    // construct classname for whether we are adding padding to left & right border or not
    const videoClassName = constructCn(
        'video',
        !noBorderPaddingImage && 'video--padding'
    );
    const previewImageClassName = constructCn(
        'link-card-wrapper__preview-image',
        !noBorderPaddingImage && 'link-card-wrapper__preview-image--padding'
    );

    return (
        <React.Fragment>
            {showVideo && (
                <div
                    className={videoClassName}
                    dangerouslySetInnerHTML={{ __html: embedHtml }}
                />
            )}

            {showPreviewImage && (
                <ResponsivePicture
                    className={previewImageClassName}
                    breakpoints={breakpoints}
                    cloudinaryID={previewImage.src}
                    alt={`preview-${previewImage.alt}`}
                    lazyLoad
                    useShine
                />
            )}

            <div className={previewDescriptionClassName}>
                <h3 className="preview-description-wrapper__preview-url">
                    {previewTitle}
                </h3>
                <p className="preview-description-wrapper__preview-title">
                    {previewDescription}
                </p>
            </div>
        </React.Fragment>
    );
};

const LinkContent = ({
    className,
    noBorderPaddingImage,
    preview,
    location,
    contentLink,
}) => {
    const { externalUrl } = preview;
    const url = location === SEARCH_RESULTS ? contentLink : externalUrl;
    const componentClassName = constructCn(
        'component-UnifiedPostCard-LinkContent',
        className
    );

    return (
        <div className={componentClassName}>
            <div className="link-card-wrapper">
                <a href={url} target="_blank" rel="noreferrer">
                    <PreviewSection
                        preview={preview}
                        noBorderPaddingImage={noBorderPaddingImage}
                    />
                </a>
            </div>
        </div>
    );
};

LinkContent.propTypes = {
    className: PropTypes.string,
    preview: PropTypes.shape({
        /**
         * Url displayed as title for preview card
         */
        previewTitle: PropTypes.string,
        /**
         * Description text for preview card
         */
        previewDiscussion: PropTypes.string,
        /**
         * Image information for preview
         */
        previewImage: PropTypes.shape({
            src: PropTypes.string,
            alt: PropTypes.string,
        }),
        /**
         * The Url that the link is linked to, the external page
         */
        externalUrl: PropTypes.string,
        /**
         * The html for videos
         */
        embedHtml: PropTypes.string,
    }),
    noBorderPaddingImage: PropTypes.bool,
    location: PropTypes.string,
    contentLink: PropTypes.string,
};

LinkContent.defaultProps = {
    className: '',
    preview: {
        previewTitle: '',
        previewDescription: '',
        previewImage: null,
        externalUrl: '',
        embedHtml: null,
    },
    noBorderPaddingImage: true,
    location: '',
    contentLink: '',
};

LinkContent.displayName = 'LinkContent';

export default LinkContent;
